import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import AccessPanel from './AccessPanel';

export default function UserDetails() {
  const dispatch = useDispatch();
  const {
    details: { values },
  } = useSelector(store => store);

  useEffect(() => {
    dispatch({ type: 'LOAD_ACCESS', access: {} });
  }, []);

  return (
    <>
      <div className="d-flex justify-content-between mb-3">
        <h5 className="font-weight-bold">Site Access</h5>
      </div>
      <AccessPanel user={values} />
    </>
  );
}

